"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _AspectRatio = _interopRequireDefault(require("./AspectRatio"));
var _Body = _interopRequireDefault(require("./Body"));
var _Caption = _interopRequireDefault(require("./Caption"));
var _CardHorizontal = require("./CardHorizontal");
var _CardNavigation = require("./CardNavigation");
var _Context = _interopRequireDefault(require("./Context"));
var _Description = _interopRequireDefault(require("./Description"));
var _Group = _interopRequireDefault(require("./Group"));
var _Row = _interopRequireDefault(require("./Row"));
var _excluded = ["active", "children", "className", "displayType", "selectable"],
  _excluded2 = ["children", "horizontal", "interactive"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var CardBase = function CardBase(_ref) {
  var active = _ref.active,
    children = _ref.children,
    className = _ref.className,
    displayType = _ref.displayType,
    _ref$selectable = _ref.selectable,
    selectable = _ref$selectable === void 0 ? false : _ref$selectable,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var isCardType = {
    file: displayType === 'file',
    image: displayType === 'image',
    user: displayType === 'user'
  };
  return /*#__PURE__*/_react.default.createElement(_Context.default.Provider, {
    value: {
      horizontal: false,
      interactive: false
    }
  }, /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)(className, {
      active: active,
      card: !selectable,
      'file-card': isCardType.file,
      'form-check-card form-check form-check-top-left': selectable,
      'image-card': isCardType.image,
      'user-card': isCardType.user
    }, 'card-type-asset')
  }, otherProps), selectable ? /*#__PURE__*/_react.default.createElement("div", {
    className: "card"
  }, children) : children));
};
function Card(_ref2) {
  var children = _ref2.children,
    horizontal = _ref2.horizontal,
    interactive = _ref2.interactive,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  var Container = interactive ? _CardNavigation.ClayCardNavigation : horizontal ? _CardHorizontal.ClayCardHorizontal : CardBase;
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    horizontal: horizontal
  }, otherProps), children);
}
Card.displayName = 'ClayCard';
Card.AspectRatio = _AspectRatio.default;
Card.Body = _Body.default;
Card.Caption = _Caption.default;
Card.Description = _Description.default;
Card.Group = _Group.default;
Card.Row = _Row.default;
var _default = exports.default = Card;